var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn action-btn',
            _vm.active ? 'state-active' : '',
            _vm.flex ? 'd-flex align-items-center justify-content-left' : 'd-inline'
        ],attrs:{"name":"clear","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_c('icon',{attrs:{"name":_vm.icon}}),_c('span',{staticClass:"button-title"},[_vm._v(_vm._s(_vm.buttonTitle))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }